import { trackEvent } from '@helpers/analytics';
import { isChromeBrowser } from '@helpers/appBanner';
import {
  Button,
  ButtonTheme,
  GlobeIcon,
  Typography,
  TypographyType,
} from '@vivino/js-react-common-ui';
import { generateQueryUrl, localStorage, useI18N } from '@vivino/js-web-common';
import React, { useEffect, useState } from 'react';

import styles from './appBanner.module.scss';

const TRANSLATIONS = {
  open: 'common.open',
  continue: 'common.continue',
  vivinoApp: 'common.vivino_app',
  webBrowser: 'common.web_browser',
  viewThisWineInAPP: 'common.view_this_wine_in_app',
};

const COOKIE_NAME = 'app_banner';
const COOKIE_TIME = 4 * 60 * 60 * 1000; // 4 hours

const TakeOverBanner = () => {
  const { t } = useI18N();
  const cookie = localStorage.getItem(COOKIE_NAME) || JSON.stringify({});

  const parsedCookie = JSON.parse(cookie);
  const validCookie = parsedCookie?.expires > new Date().getTime(); // Check if cookie is still valid/expired

  const [showBanner, setShowBanner] = useState(!validCookie);

  function handleOpenAppClick() {
    trackEvent({
      event: 'Download Banner - Action',
      props: {
        Action: 'app',
      },
    });
  }

  function handleContinueClick() {
    const date = new Date();
    const value = JSON.stringify({ expires: date.getTime() + COOKIE_TIME });
    localStorage.setItem(COOKIE_NAME, value);

    trackEvent({
      event: 'Download Banner - Action',
      props: {
        Action: 'web',
      },
    });

    setShowBanner(false);
  }

  useEffect(() => {
    if (showBanner) {
      trackEvent({
        event: 'Download Banner - Show',
      });
    }
  }, [showBanner]);

  const userAgent = globalThis.navigator?.userAgent;
  const isAndroid = userAgent?.match(/Android/i);

  if (isAndroid && !isChromeBrowser()) {
    return null;
  }

  const url = isAndroid
    ? `https://app.vivino.com${globalThis.location?.pathname}${globalThis.location?.search}`
    : globalThis.__APPLE_APPSTORE_URL__;

  const appStoreButtonUrl = generateQueryUrl({
    baseUrl: url,
    params: [
      {
        name: 'utm_source',
        value: 'web_banner_large',
      },
      {
        name: 'app_store_url',
        value: isAndroid ? globalThis.__GOOGLE_PLAY_URL__ : globalThis.__APPLE_APPSTORE_URL__,
      },
    ],
  });

  if (!showBanner) {
    return null;
  }

  return (
    <div className={styles.takeover}>
      <Typography type={TypographyType.LabelLarge}>{t(TRANSLATIONS.viewThisWineInAPP)}</Typography>
      <div className={styles.ctaContainer}>
        <div className={styles.text}>
          <div className={styles.appImage}></div>
          <Typography type={TypographyType.LabelLarge}>{t(TRANSLATIONS.vivinoApp)}</Typography>
        </div>
        <div className={styles.button}>
          <Button
            fullWidth
            href={appStoreButtonUrl}
            theme={ButtonTheme.Primary}
            onClick={handleOpenAppClick}
          >
            {t(TRANSLATIONS.open)}
          </Button>
        </div>
      </div>
      <div className={styles.ctaContainer}>
        <div className={styles.text}>
          <div className={styles.globe}>
            <GlobeIcon />
          </div>
          <Typography type={TypographyType.LabelLarge}>{t(TRANSLATIONS.webBrowser)}</Typography>
        </div>
        <div className={styles.button}>
          <Button fullWidth onClick={handleContinueClick}>
            {t(TRANSLATIONS.continue)}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TakeOverBanner;
